import { useState } from 'react';
import { Grid } from '@mui/material';
import {
  useOperatorsVehiclesQuery,
  useOperatorsVehiclesTemporaryBaseQuery,
} from 'api/queries/operators';
import FormCard from 'components/FormCard';
import VehicleDefaultLocationForm from 'components/forms/FleetFormFactory/VehicleDefaultLocationForm';
import VehicleLocationTableForm from 'components/forms/FleetFormFactory/VehicleLocationTableForm';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PaginationQueryParams } from 'api/types';

function VehicleLocationsView() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: vehicle, isSuccess: isSuccessVehicle } = useOperatorsVehiclesQuery(id!);
  const [queryParams, setQueryParams] = useState<PaginationQueryParams>({
    pageNo: '0',
  });
  const {
    data: vehicleTemporaryBases,
    isSuccess: isSuccessTemporaryBases,
    isLoading,
  } = useOperatorsVehiclesTemporaryBaseQuery(id!, queryParams);

  return (
    <Grid container item gap={6}>
      {isSuccessVehicle && (
        <FormCard
          title={t('FleetView.DetailView.vehicleLocation.title')}
          sx={{
            width: '421px',
          }}
        >
          <VehicleDefaultLocationForm
            vehicle={vehicle}
            defaultValues={{
              // TODO: Find a better way to define undefined values for zod instances
              defaultLocation:
                vehicle.defaultLocation != null
                  ? {
                      placeId: vehicle.defaultLocation?.placeId as string,
                      ...vehicle.defaultLocation,
                    }
                  : { address: '', placeId: '' },
            }}
          />
        </FormCard>
      )}
      {isSuccessVehicle && isSuccessTemporaryBases && (
        <VehicleLocationTableForm
          vehicleId={vehicle.id}
          defaultValues={{ locations: vehicleTemporaryBases?.elements ?? [] }}
          setQueryParams={setQueryParams}
          isQueryLoading={isLoading}
        />
      )}
    </Grid>
  );
}

export default VehicleLocationsView;
